import React, { useContext, useEffect, useState } from 'react';

import { Aide } from '../ui/aide';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { toast } from '../ui/sonner';
import { AuthContext } from '../../context/AuthContext';
import { clientsAPI } from '../../lib/api';
import { messageErreur } from '../../lib/erreurs';

const AIDE =
  'Le client reçoit un message WhatsApp quand son camion est chargé, a passé la frontière, est arrivé et a livré (avec le lien du bon de livraison). Jamais un montant. Éteint tant que vous ne l’allumez pas.';

/**
 * Interrupteur « Prévenir ce client » de la fiche client. Réservé à
 * l'administrateur de la société; les autres profils ne le voient pas.
 */
export const MessagesClientSwitch = ({ client, onChange }) => {
  const auth = useContext(AuthContext);
  const autorise = Boolean(auth?.isAdminSociete || auth?.isSuperAdmin);
  const [actif, setActif] = useState(Boolean(client?.notify_trip_steps));
  const [enCours, setEnCours] = useState(false);

  useEffect(() => {
    setActif(Boolean(client?.notify_trip_steps));
  }, [client?.id, client?.notify_trip_steps]);

  if (!autorise || !client?.id) return null;

  const changer = async (valeur) => {
    setEnCours(true);
    try {
      const mis = await clientsAPI.setTripNotifications(client.id, valeur);
      setActif(Boolean(mis?.notify_trip_steps));
      onChange?.(mis);
      toast.success(valeur ? 'Le client sera prévenu' : 'Le client ne sera plus prévenu');
    } catch (err) {
      toast.error(messageErreur(err, 'Le réglage n’a pas pu être enregistré'));
    } finally {
      setEnCours(false);
    }
  };

  return (
    <div className="flex items-center justify-between gap-3" data-testid="messages-client">
      <div className="flex items-center gap-1">
        <Label htmlFor="messages-client-switch">Prévenir ce client par WhatsApp</Label>
        <Aide titre="Prévenir ce client">{AIDE}</Aide>
      </div>
      <Switch
        id="messages-client-switch"
        checked={actif}
        disabled={enCours}
        onCheckedChange={changer}
        aria-label="Prévenir ce client par WhatsApp"
        data-testid="messages-client-switch"
      />
    </div>
  );
};

export default MessagesClientSwitch;
